module.exports = __webpack_public_path__ + "img/ai-button.6ffa677d.svg";